export default __webpack_public_path__ + "static/media/legguards_of_the_wicked.bf363cc6.jpg";